import styled from 'styled-components';

import { CollapseAppearance } from './Collapse';

import { Color } from '../../../shared/constants/Colors';
import { Transition } from '../../../shared/constants/Styles';

export const Container = styled.div`
  display: inline-block;
  border-radius: 5px;
  width: ${({ isFullWidth }) => (isFullWidth ? '100%' : 'initial')};

  ${({ appearance, isFullWidth }) =>
    appearance === CollapseAppearance.CLASSIC &&
    `
    border: 2px solid ${Color.MYSTIC};
    margin: ${isFullWidth ? '0' : '15px 0'};
`}

  ${({ appearance }) => appearance === CollapseAppearance.MINIMAL && ``}
`;

export const StyledMain = styled.div`
  cursor: pointer;
  outline: 0;
  border-radius: inherit;
  width: 100%;

  svg {
    transform: ${({ isContentShown }) =>
      isContentShown ? 'translate(40%) rotate(-180deg)' : 'none'};
    transition: ${Transition.ALL_EASE};
  }
`;

export const StyledContent = styled.div`
  transition: ${Transition.HEIGHT};
  height: ${({ height }) => height}px;
  overflow: hidden;
  width: 100%;
`;
